import React__default, { useMemo, useCallback, useEffect } from 'react';

var Ads = function Ads(props) {
  var _props$adConfig = props.adConfig,
    dfpNetworkId = _props$adConfig.dfpNetworkId,
    targetingConfig = _props$adConfig.targetingConfig,
    adUnitPath = _props$adConfig.adUnitPath;
  var renderedAdSlots = useMemo(function () {
    return [];
  }, []);
  var uniqueId = props.uniqueId,
    numberOfAds = props.numberOfAds,
    adSizes = props.adSizes,
    onRenderHandler = props.onRenderHandler,
    onProcessedAllAdsHandler = props.onProcessedAllAdsHandler,
    adStretchOptions = props.adStretchOptions,
    adSpacing = props.adSpacing;
  var buildAdDivs = function buildAdDivs() {
    var adDivs = [];
    for (var i = 0; i < numberOfAds; i++) {
      adDivs.push( /*#__PURE__*/React__default.createElement("div", {
        id: "".concat(uniqueId ? uniqueId + '-' : '', "ad-slot-").concat(i),
        key: "".concat(uniqueId ? uniqueId + '-' : '', "ad-slot-").concat(i),
        className: "mb-5"
      }));
    }
    return adDivs;
  };
  var checkAndInjectGooglePublisherTag = function checkAndInjectGooglePublisherTag() {
    if (!window.googletag) {
      var head = document.getElementsByTagName('head')[0];
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js';
      head.appendChild(script);
    }
  };
  var adSlotElementIds = useMemo(function () {
    return [];
  }, []);
  var stretchAds = useCallback(function () {
    if (adStretchOptions && adStretchOptions.isStretchable) {
      adSlotElementIds.forEach(function (elementId) {
        var adElement = document.querySelector("#".concat(elementId));
        if (adElement && adElement.parentElement && adElement.parentElement.parentElement) {
          var containerWidth = window.getComputedStyle(adElement.parentElement.parentElement).width;
          var adWidth = window.getComputedStyle(adElement).width;
          var scaleFactor = parseInt(containerWidth) / parseInt(adWidth);
          if (adStretchOptions.isShrinkOnly && scaleFactor > 1.0) {
            adElement.style.transform = 'scale(1)';
          } else {
            adElement.style.transform = "scale(".concat(scaleFactor, ")");
          }
          adElement.parentElement.style.width = "".concat(scaleFactor * adElement.clientWidth, "px");
          adElement.parentElement.style.height = "".concat(scaleFactor * adElement.clientHeight, "px");
        }
      });
    }
  }, [adSlotElementIds, adStretchOptions]);
  useEffect(function () {
    var removePaddingFromLastRenderedAd = function removePaddingFromLastRenderedAd() {
      var adsContainer = document.querySelector("#".concat(uniqueId ? uniqueId + '-' : '', "ads-container"));
      if (adsContainer) {
        var visibleElements = [];
        for (var i = 0; i < adsContainer.children.length; i++) {
          var _ref;
          var element = adsContainer.children[i];
          element.style.marginBottom = (_ref = "".concat(adSpacing, "px")) !== null && _ref !== void 0 ? _ref : '20px';
          element.style.height = "".concat(adSizes[0][1], "px");
          if (element.style.display !== 'none') {
            visibleElements.push(element);
          }
        }
        if (visibleElements.length) {
          visibleElements[visibleElements.length - 1].style.marginBottom = '0';
        }
      }
    };
    var filledAdSlotsCount = 0;
    var processedAds = 0;
    var renderHandler = function renderHandler(event) {
      processedAds++;
      !event.isEmpty && filledAdSlotsCount++;
      adSlotElementIds.push(event.slot.getSlotElementId());
      if (processedAds === numberOfAds) {
        removePaddingFromLastRenderedAd();
        stretchAds();
        if (onProcessedAllAdsHandler) {
          onProcessedAllAdsHandler(filledAdSlotsCount);
        }
      }
      onRenderHandler && onRenderHandler(event);
    };
    var buildAdSlot = function buildAdSlot(id) {
      var adSlot = googletag.defineSlot("".concat(dfpNetworkId, "/").concat(adUnitPath), adSizes, id);
      if (targetingConfig && adSlot) {
        if (targetingConfig.ListingType) adSlot.setTargeting('ListingType', targetingConfig.ListingType.join());
        if (targetingConfig.SpaceUse) adSlot.setTargeting('SpaceUse', targetingConfig.SpaceUse.join());
        if (targetingConfig.PropertyType) {
          adSlot.setTargeting('PropertyType', targetingConfig.PropertyType.join());
        }
        if (targetingConfig.at) adSlot.setTargeting('at', targetingConfig.at);
        if (targetingConfig.countryCode) adSlot.setTargeting('countryCode', targetingConfig.countryCode);
        if (targetingConfig.csauth) adSlot.setTargeting('csauth', targetingConfig.csauth);
        if (targetingConfig.qa) adSlot.setTargeting('qa', targetingConfig.qa);
        if (targetingConfig.smi) adSlot.setTargeting('smi', targetingConfig.smi.join());
        if (targetingConfig.culture) adSlot.setTargeting('culture', targetingConfig.culture);
        if (targetingConfig.auction) adSlot.setTargeting('auction', targetingConfig.auction);
      }
      adSlot && adSlot.addService(googletag.pubads());
      return adSlot;
    };
    var setupAd = function setupAd(id) {
      googletag.cmd.push(function () {
        var adSlot = buildAdSlot(id);
        adSlot && renderedAdSlots.push(adSlot);

        //@ts-ignore
        googletag.pubads().enableAsyncRendering();
        googletag.pubads().collapseEmptyDivs();
        googletag.pubads().addEventListener('slotRenderEnded', function (event) {
          if (event.slot === adSlot) {
            renderHandler && renderHandler(event);
          }
        });
        googletag.enableServices();
      });
    };
    var renderAllAds = function renderAllAds() {
      window.googletag = window.googletag || {
        cmd: []
      };
      for (var i = 0; i < numberOfAds; i++) {
        setupAd("".concat(uniqueId ? uniqueId + '-' : '', "ad-slot-").concat(i));
      }
      googletag.cmd.push(function () {
        //@ts-ignore
        googletag.pubads().updateCorrelator();
      });
      googletag.cmd.push(function () {
        for (var _i = 0; _i < numberOfAds; _i++) {
          googletag.display("".concat(uniqueId ? uniqueId + '-' : '', "ad-slot-").concat(_i));
        }
      });
    };
    var run = function run() {
      checkAndInjectGooglePublisherTag();
      renderAllAds();
    };
    var cleanUp = function cleanUp() {
      if (googletag.destroySlots) {
        googletag.destroySlots(renderedAdSlots);
      }
      window.removeEventListener('resize', stretchAds);
    };
    run();
    window.addEventListener('resize', stretchAds);
    return function () {
      cleanUp();
    };
  }, [adSizes, adSlotElementIds, adSpacing, adUnitPath, dfpNetworkId, numberOfAds, onProcessedAllAdsHandler, onRenderHandler, renderedAdSlots, stretchAds, targetingConfig, uniqueId]);
  return /*#__PURE__*/React__default.createElement("div", {
    id: "".concat(uniqueId ? uniqueId + '-' : '', "ads-container"),
    className: "overflow-hidden last:mb-0"
  }, buildAdDivs());
};

export { Ads };
//# sourceMappingURL=news-ads.esm.js.map
